(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4881],{

/***/ 64881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65988);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_flatpickr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15953);
/* harmony import */ var flatpickr_dist_themes_material_red_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94684);
/* harmony import */ var flatpickr_dist_themes_material_red_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(flatpickr_dist_themes_material_red_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _styles_Userpage_module_css__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(15094);
/* harmony import */ var _styles_Userpage_module_css__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_styles_Userpage_module_css__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(19578);
/* harmony import */ var react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(89019);
/* harmony import */ var react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(4143);
/* harmony import */ var react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(48568);
/* harmony import */ var react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(10394);
/* harmony import */ var react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(65287);
/* harmony import */ var react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(38358);
/* harmony import */ var react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(41285);
/* harmony import */ var _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6644);
/* harmony import */ var react_alert__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19412);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52500);
/* harmony import */ var timezone_select_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11375);
/* harmony import */ var _lib_gtag__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61474);
/* harmony import */ var validator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48966);
/* harmony import */ var validator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(validator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _stripe_stripe_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54465);
/* harmony import */ var _stripe_react_stripe_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86664);
/* harmony import */ var _stripe_react_stripe_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_stripe_react_stripe_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _contexts_Auth__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92842);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41664);





















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var DateTime = (__webpack_require__(68565)/* .DateTime */ .ou);
var RegisterSlide = function(props) {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone ? Intl.DateTimeFormat().resolvedOptions().timeZone : "America/Los_Angeles";
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)({
        "name": null,
        "account_type": "business",
        "email": "",
        'password': null,
        'confirm_password': null
    }), /*#__PURE__*/ form = ref3[0], setForm = ref3[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)({
        emailInvalid: null,
        passwordInvalid: null,
        nameInvalid: null
    }), errorObj = ref2[0], setErrorObj = ref2[1];
    var handleChange = function(e) {
        var _target = e.target, name = _target.name, value = _target.value;
        var newForm = _objectSpread({}, form);
        newForm[name] = value;
        setForm(newForm);
    };
    var checkErrors = function() {
        if (form.password !== form.confirm_password) {
            var newError = _objectSpread({}, errorObj);
            newError.passwordInvalid = "Passwords do not match";
            setErrorObj(newError);
            return false;
        }
        if (form.password.length < 8) {
            var newError1 = _objectSpread({}, errorObj);
            newError1.passwordInvalid = "Password too short";
            setErrorObj(newError1);
            return false;
        }
        if (!form.name) {
            var newError2 = _objectSpread({}, errorObj);
            newError2.nameInvalid = "Please enter a username";
            setErrorObj(newError2);
            return false;
        }
        return true;
    };
    var submitRegister = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            var bool, ref, user, error, rand, payload, profile, convo, newError;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        setLoading(true);
                        props.setCheckUser(false);
                        bool = checkErrors();
                        if (bool) {
                            _ctx.next = 7;
                            break;
                        }
                        setLoading(false);
                        return _ctx.abrupt("return");
                    case 7:
                        _ctx.next = 9;
                        return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_7__/* .supabase.auth.signUp */ .O.auth.signUp({
                            email: form.email,
                            password: form.password
                        });
                    case 9:
                        ref = _ctx.sent;
                        user = ref.user;
                        error = ref.error;
                        if (error) {
                            _ctx.next = 29;
                            break;
                        }
                        _lib_gtag__WEBPACK_IMPORTED_MODULE_15__/* .event */ .B({
                            action: 'client_register'
                        });
                        rand = (Math.random() + 1).toString(36).substring(7);
                        payload = {
                            user_id: user.id,
                            name: form.name,
                            account_type: "client",
                            email: form.email,
                            unique_slug: rand,
                            timezone: tz
                        };
                        _ctx.next = 18;
                        return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_7__/* .supabase.from */ .O.from("main_profile").insert(payload);
                    case 18:
                        profile = _ctx.sent;
                        //update state here?
                        props.handleUser({
                            email: form.email,
                            name: form.name,
                            id: user.id,
                            profile_id: profile.data[0].id
                        });
                        if (!props.conversation) {
                            _ctx.next = 24;
                            break;
                        }
                        _ctx.next = 23;
                        return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_7__/* .supabase.from */ .O.from("main_conversation").update({
                            client_profile_id: profile.data[0].id
                        }).match({
                            uuid: props.conversation
                        });
                    case 23:
                        convo = _ctx.sent;
                    case 24:
                        _ctx.next = 26;
                        return fetch("/api/contact/register", {
                            method: "POST",
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                email: form.email,
                                client: true,
                                coach_name: props.profile.name,
                                brand_logo: props.profile.brand_logo ? props.profile.brand_logo : null
                            })
                        });
                    case 26:
                        props.setSubPage(0);
                        _ctx.next = 30;
                        break;
                    case 29:
                        {
                            newError = _objectSpread({}, errorObj);
                            newError.emailInvalid = error.message;
                            setErrorObj(newError);
                        }
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitRegister(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
        className: " space-y-6",
        method: "POST",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                className: "font-semibold text-xl text-slate-900",
                children: "Register to sign up for this mentor's services"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "shadow-sm rounded-md ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "label",
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                id: "name",
                                name: "name",
                                type: "text",
                                required: true,
                                className: "".concat(errorObj.nameInvalid ? ' focus:ring-pink-500 text-pink-600' : ' focus:border-slate-500 focus:ring-slate-500 ', " shadow-sm mt-1 z-10 appearance-none  relative block w-full px-3 py-2 border border-slate-300 rounded-md  focus:outline-none focus:ring-1 focus:z-10 sm:text-sm"),
                                onChange: handleChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "label",
                                children: "Email address"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                id: "email-address",
                                name: "email",
                                type: "email",
                                defaultValue: form.email,
                                autoComplete: "email",
                                required: true,
                                className: "".concat(errorObj.emailInvalid ? ' focus:ring-pink-500 text-pink-600' : ' focus:border-slate-500 focus:ring-slate-500 ', " shadow-sm mt-1 z-10 appearance-none  relative block w-full px-3 py-2 border border-slate-300 rounded-md  focus:outline-none focus:ring-1 focus:z-10 sm:text-sm"),
                                onChange: handleChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "label",
                                children: "Password"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                id: "password",
                                name: "password",
                                type: "password",
                                autoComplete: "current-password",
                                required: true,
                                className: "".concat(errorObj.passwordInvalid ? ' focus:ring-pink-500 text-pink-600' : ' focus:border-slate-500 focus:ring-slate-500 ', " shadow-sm mt-1 z-10 appearance-none  relative block w-full px-3 py-2 border border-slate-300 rounded-md  focus:outline-none focus:ring-1 focus:z-10 sm:text-sm"),
                                onChange: handleChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "label",
                                children: "Confirm Password"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                id: "confirm_password",
                                name: "confirm_password",
                                type: "password",
                                autoComplete: "current-password",
                                required: true,
                                className: "".concat(errorObj.passwordInvalid ? ' focus:ring-pink-500 text-pink-600' : ' focus:border-slate-500 focus:ring-slate-500 ', " shadow-sm mt-1 z-10 appearance-none  relative block w-full px-3 py-2 border border-slate-300 rounded-md  focus:outline-none focus:ring-1 focus:z-10 sm:text-sm"),
                                onChange: handleChange
                            })
                        ]
                    })
                ]
            }),
            errorObj.nameInvalid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "block text-pink-600",
                children: errorObj.nameInvalid
            }),
            errorObj.passwordInvalid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "block text-pink-600",
                children: errorObj.passwordInvalid
            }),
            errorObj.emailInvalid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "block text-pink-600",
                children: errorObj.emailInvalid
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                        className: "text-slate-600",
                        style: {
                            fontSize: '13px'
                        },
                        children: [
                            "By registering for a Plaza account, you agree to our ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_14__["default"], {
                                href: "/terms-conditions",
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                    target: "_blank",
                                    className: "underline underline-4",
                                    children: "terms and conditions"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                        onClick: submitRegister,
                        disabled: loading,
                        type: "submit",
                        className: "group relative w-full flex mt-2 justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-slate-700 hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-zinc-500",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                className: "absolute left-0 inset-y-0 flex items-center pl-3"
                            }),
                            loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                className: "animate-spin ml-1 mr-3 h-5 w-5 text-white",
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                                        className: "opacity-25",
                                        cx: "12",
                                        cy: "12",
                                        r: "10",
                                        stroke: "currentColor",
                                        strokeWidth: "4"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        className: "opacity-75",
                                        fill: "currentColor",
                                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    })
                                ]
                            }) : 'Register'
                        ]
                    })
                ]
            })
        ]
    }));
};
var SendMessage = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), success = ref[0], setSuccess = ref[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)({
        name: "",
        email: "",
        message: ""
    }), message = ref4[0], setMessage = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), loading = ref5[0], setLoading = ref5[1];
    var ref6 //update error to handle multiple cases
     = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), error = ref6[0], setError = ref6[1];
    var handleMessage = function(e) {
        e.preventDefault();
        var newMessage = _objectSpread({}, message);
        newMessage[e.target.name] = e.target.value;
        setMessage(newMessage);
    };
    var submitMessage = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var cleanMessage, resp;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        cleanMessage = _objectSpread({}, message);
                        if (validator__WEBPACK_IMPORTED_MODULE_16___default().isEmail(cleanMessage.email)) {
                            _ctx.next = 6;
                            break;
                        }
                        setLoading(false);
                        setError("Invalid Email");
                        return _ctx.abrupt("return");
                    case 6:
                        error && setError(null);
                        _ctx.next = 9;
                        return fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_9__/* .server */ .fw, "/api/contact/messages/newMessage"), {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            method: "POST",
                            body: JSON.stringify({
                                name: cleanMessage.name,
                                email: cleanMessage.email,
                                message: cleanMessage.message,
                                profile_id: props.profile.id,
                                activity: {
                                    id: props.activity.id,
                                    name: props.activity.booking_name
                                },
                                source: "booking page" //need to add source?
                            })
                        });
                    case 9:
                        resp = _ctx.sent;
                        setLoading(false);
                        setSuccess(resp.ok);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitMessage() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: " p-4 rounded-lg ",
        style: {
            minHeight: "200px"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                className: "text-slate-700 font-bold text-2xl mb-1",
                children: "Send Message"
            }),
            success ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "pt-5 mt-5 pb-12 text-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        className: "mx-auto mb-2 text-green-600",
                        size: 45
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        className: "font-bold text-xl mb-3 text-slate-700",
                        children: "Message Sent"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                        className: "text-slate-900",
                        children: [
                            "You'll receive a response via email",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {})
                        ]
                    })
                ]
            }) : success === false ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "pt-5 mt-5 pb-12 text-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        className: "mx-auto mb-2 text-red-500",
                        size: 24
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        className: "text-slate-900 font-semibold text-lg",
                        children: "An error occurred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        className: "text-slate-600 mb-4",
                        children: "Please refresh the page and try again.  If this error persists, please email us as info@plaza.so"
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "text-left",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "label",
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                type: "text",
                                required: true,
                                name: "name",
                                className: "mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-slate-500 focus:ring-slate-500 block w-full rounded-md sm:text-sm focus:ring-1",
                                defaultValue: message.name,
                                onChange: handleMessage,
                                disabled: loading
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: "label",
                                        children: "Email"
                                    }),
                                    error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: "text-sm text-red-500",
                                        children: error
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                type: "email",
                                required: true,
                                name: "email",
                                className: "mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-slate-500 focus:ring-slate-500 block w-full rounded-md sm:text-sm focus:ring-1",
                                disabled: loading,
                                defaultValue: message.email,
                                onChange: handleMessage
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "label",
                                children: "Message"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("textarea", {
                                rows: 3,
                                size: "sm",
                                name: "message",
                                className: "mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-slate-500 focus:ring-slate-500 block w-full rounded-md sm:text-sm focus:ring-1",
                                defaultValue: message.message,
                                onChange: handleMessage,
                                disabled: loading
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                        className: "w-full mt-2 bg-slate-700 shadow-md shadow-slate-500/50 rounded-md py-2 text-sm font-semibold text-white text-center hover:bg-zinc-900",
                        onClick: submitMessage,
                        disabled: loading,
                        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                className: "animate-spin ml-1 mr-3 h-5 w-5 text-white",
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                                        className: "opacity-25",
                                        cx: "12",
                                        cy: "12",
                                        r: "10",
                                        stroke: "currentColor",
                                        strokeWidth: "4"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        className: "opacity-75",
                                        fill: "currentColor",
                                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    })
                                ]
                            })
                        }) : 'Send Message'
                    })
                ]
            })
        ]
    }));
};
var Checkout = function(props) {
    var stripe = (0,_stripe_react_stripe_js__WEBPACK_IMPORTED_MODULE_12__.useStripe)();
    var elements = (0,_stripe_react_stripe_js__WEBPACK_IMPORTED_MODULE_12__.useElements)();
    var alert = (0,react_alert__WEBPACK_IMPORTED_MODULE_8__/* .useAlert */ .VY)();
    var user = (0,_contexts_Auth__WEBPACK_IMPORTED_MODULE_13__/* .useAuth */ .a)().user;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), message = ref[0], setMessage = ref[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), loading = ref7[0], setLoading = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), isLoading = ref8[0], setIsLoading = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), confirmed = ref9[0], setConfirmed = ref9[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (!stripe) {
            return;
        }
        var clientSecret = new URLSearchParams(window.location.search).get("payment_intent_client_secret");
        if (!clientSecret) {
            return;
        }
        stripe.retrievePaymentIntent(clientSecret).then(function(param) {
            var paymentIntent = param.paymentIntent;
            switch(paymentIntent.status){
                case "succeeded":
                    break;
                case "processing":
                    setMessage("Your payment is processing.");
                    break;
                case "requires_payment_method":
                    setMessage("Your payment was not successful, please try again.");
                    break;
                default:
                    setMessage("Something went wrong.");
                    break;
            }
        });
    }, [
        stripe
    ]);
    var handleSubmit = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            var error1, meeting, dateStr, appointment_datetime, timezone, meeting_dates, durationInMinutes, duration_obj, numWeeks, appointmentDateTime, mData, payload, uuid, utc_date, url, runAt, remindAt, dateSubscription, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, m, payloadMeeting, mObj, i, meetingUTC, meetingRes, newMeeting, i1, apptDt;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        setIsLoading(true);
                        if (!(!stripe || !elements)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        _ctx.next = 6;
                        return stripe.confirmPayment({
                            elements: elements,
                            confirmParams: {
                                // Make sure to change this to your payment completion page
                                return_url: _config__WEBPACK_IMPORTED_MODULE_9__/* .server */ .fw + "/meeting/confirmed/" + props.activity.id
                            },
                            redirect: 'if_required'
                        });
                    case 6:
                        error1 = _ctx.sent.error;
                        if (error1) {
                            _ctx.next = 55;
                            break;
                        }
                        meeting = props.meeting;
                        dateStr = meeting.dateStr, appointment_datetime = meeting.appointment_datetime, timezone = meeting.timezone, meeting_dates = meeting.meeting_dates;
                        durationInMinutes = props.activity.duration_period === "minutes" ? props.activity.duration_int : props.activity.duration_int * 60;
                        duration_obj = {
                            minutes: durationInMinutes
                        };
                        numWeeks = props.activity.schedule_period === "week" ? props.activity.schedule_int : props.activity.schedule_int * 4;
                        appointmentDateTime = DateTime.fromISO(appointment_datetime);
                        ;
                        ;
                        ;
                        ;
                        ;
                        ;
                        ;
                        dateSubscription = DateTime.now().toFormat("yyyy-LLL-dd-HH-mm");
                        if (props.activity.multiple) {
                            _ctx.next = 26;
                            break;
                        }
                        {
                            mData = {
                                v_appointment_datetime: appointmentDateTime.setZone(props.meeting.timezone).toLocaleString(DateTime.DATETIME_FULL),
                                c_appointment_datetime: appointmentDateTime.setZone(props.activity.timezone).toLocaleString(DateTime.DATETIME_FULL)
                            };
                            utc_date = appointmentDateTime.toUTC().toFormat('y-L-d-H-m').split("-").map(function(str) {
                                return parseInt(str);
                            });
                            payload = {
                                appointment_datetime: appointment_datetime,
                                viewer_name: meeting.name,
                                viewer_email: meeting.email,
                                notes: meeting.notes,
                                status: 'upcoming',
                                duration: durationInMinutes,
                                viewer_timezone: timezone,
                                type: '1-on-1',
                                cost: props.activity.meeting_cost,
                                subtype: meeting.rand,
                                user_id: props.activity.user_id,
                                activity: props.activity.id,
                                client_user_id: user ? user.id : null
                            };
                        }
                        _ctx.next = 47;
                        break;
                    case 26:
                        mData = [];
                        payload = [];
                        utc_date = [];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _ctx.prev = 30;
                        for(_iterator = meeting_dates[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            m = _step.value;
                            payloadMeeting = {
                                appointment_datetime: m,
                                viewer_name: meeting.name,
                                viewer_email: meeting.email,
                                notes: meeting.notes,
                                status: 'upcoming',
                                duration: durationInMinutes,
                                viewer_timezone: timezone,
                                type: '1-on-1',
                                cost: props.activity.meeting_cost,
                                subtype: meeting.rand,
                                user_id: props.activity.user_id,
                                activity: props.activity.id,
                                client_user_id: user ? user.id : null
                            };
                            mObj = {
                                v_appointment_datetime: DateTime.fromISO(m).setZone(props.meeting.timezone).toLocaleString(DateTime.DATETIME_FULL),
                                c_appointment_datetime: DateTime.fromISO(m).setZone(props.activity.timezone).toLocaleString(DateTime.DATETIME_FULL),
                                iso: m
                            };
                            mData.push(mObj);
                            payload.push(payloadMeeting);
                        }
                        _ctx.next = 38;
                        break;
                    case 34:
                        _ctx.prev = 34;
                        _ctx.t0 = _ctx["catch"](30);
                        _didIteratorError = true;
                        _iteratorError = _ctx.t0;
                    case 38:
                        _ctx.prev = 38;
                        _ctx.prev = 39;
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    case 41:
                        _ctx.prev = 41;
                        if (!_didIteratorError) {
                            _ctx.next = 44;
                            break;
                        }
                        throw _iteratorError;
                    case 44:
                        return _ctx.finish(41);
                    case 45:
                        return _ctx.finish(38);
                    case 46:
                        for(i = 0; i < props.activity.weekly_meeting_amount; i++){
                            meetingUTC = DateTime.fromISO(meeting_dates[i]).toUTC().toFormat('y-L-d-H-m').split("-").map(function(str) {
                                return parseInt(str);
                            });
                            utc_date.push(meetingUTC);
                        }
                    case 47:
                        _ctx.next = 49;
                        return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_7__/* .supabase.from */ .O.from("main_meeting").insert(payload);
                    case 49:
                        meetingRes = _ctx.sent;
                        newMeeting = meetingRes.data[0];
                        if (props.activity.multiple) {
                            url = '/api/contact/multiple';
                            runAt = DateTime.now().plus({
                                minutes: 1
                            }).toISO();
                            uuid = [];
                            for(i1 = 0; i1 < newMeeting.length; i1++){
                                apptDt = mData[i1].iso;
                                mData[i1].uuid = newMeeting.filter(function(obj) {
                                    return Date.parse(apptDt) === Date.parse(obj.appointment_datetime);
                                })[0].room_uuid;
                            }
                        } else {
                            mData.uuid = newMeeting.room_uuid;
                            url = '/api/contact/demo';
                            runAt = appointmentDateTime.setZone(props.meeting.timezone).plus({
                                minutes: -5
                            }).toISO();
                            remindAt = appointmentDateTime.setZone(props.meeting.timezone).plus({
                                minutes: -60
                            }).toISO();
                        }
                        fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                email: newMeeting.viewer_email,
                                meeting_data: mData,
                                utc_date: utc_date,
                                creator_email: props.activity.profile.email,
                                notes: newMeeting.notes,
                                number_of_weeks: numWeeks,
                                weekly_amount: props.activity.weekly_meeting_amount,
                                iso_dates: meeting_dates.slice(0, props.activity.weekly_meeting_amount),
                                duration_obj: duration_obj,
                                subtype: meeting.rand,
                                creator_name: props.activity.profile.name,
                                creator_timezone: props.activity.timezone,
                                creator_profile_id: props.activity.profile.id,
                                calendar_sync: props.activity.profile.calendar_sync,
                                description: props.activity.description.substring(0, 100) + " ...",
                                timezone: newMeeting.viewer_timezone,
                                cost: props.activity.meeting_cost,
                                viewer_name: props.meeting.name,
                                activity_title: props.activity.booking_name,
                                id: newMeeting.room_uuid,
                                brand_logo: props.activity.profile.brand_logo,
                                runAt: runAt,
                                remindAt: remindAt,
                                endAt: appointmentDateTime.setZone(props.meeting.timezone).plus({
                                    minutes: durationInMinutes
                                }).toISO(),
                                recurring: props.activity.recurring
                            })
                        }).then(function(response) {
                            if (!response.ok) throw new Error(response.status);
                            setConfirmed(true);
                            console.log("Register email sent");
                            setIsLoading(false);
                        }).catch(function(error) {
                            console.log(error);
                            alert.error("Unable to send email confirmation");
                            console.log("Unable to send email confirmation");
                            setIsLoading(false);
                        });
                        _ctx.next = 56;
                        break;
                    case 55:
                        {
                            // This point will only be reached if there is an immediate error when
                            // confirming the payment. Otherwise, your customer will be redirected to
                            // your `return_url`. For some payment methods like iDEAL, your customer will
                            // be redirected to an intermediate site first to authorize the payment, then
                            // redirected to the `return_url`.
                            if (error1.type === "card_error" || error1.type === "validation_error") {
                                setMessage(error1.message);
                            } else {
                                setMessage("An unexpected error occured.");
                            }
                        }
                    case 56:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    30,
                    34,
                    38,
                    46
                ],
                [
                    39,
                    ,
                    41,
                    45
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return confirmed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "pt-5 mt-5 pb-20 text-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                className: "mx-auto mb-2 text-green-600",
                size: 45
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                className: "font-bold text-xl mb-5",
                children: props.activity.multiple ? "Meetings confirmed!" : "Meeting confirmed!"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                children: [
                    "You will receive a confirmation email shortly.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small", {
                        className: "text-slate-600",
                        children: props.activity.multiple ? "You'll also receive a video link\n  5 minutes before each meeting." : "You'll also receive a video link\n  5 minutes before your meeting."
                    }),
                    user && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "mt-5",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_14__["default"], {
                            href: "/dashboard",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                className: "w-full mt-5 bg-slate-700 shadow-md shadow-slate-500/50 rounded-md py-2 px-2 text-sm font-semibold text-white text-center hover:bg-zinc-900",
                                children: "View Dashboard"
                            })
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "mt-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
            id: "payment-form",
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_stripe_react_stripe_js__WEBPACK_IMPORTED_MODULE_12__.PaymentElement, {
                    id: "payment-element",
                    onReady: function() {
                        return setTimeout(function() {
                            setLoading(true);
                        }, 50);
                    }
                }),
                loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "text-right text-zinc-200 mt-2 ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "flex justify-start",
                                style: {
                                    fontSize: 9
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: "text-zinc-900",
                                        children: "Powered by "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                        alt: "Stripe",
                                        src: "https://d2j5mnrqpo6nvp.cloudfront.net/static/img/stripe.svg",
                                        width: 31.55,
                                        height: 15
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                            className: "w-full mt-5 bg-slate-700 shadow-md shadow-slate-500/50 rounded-md py-2 text-sm font-semibold text-white text-center hover:bg-zinc-900",
                            disabled: isLoading || !stripe || !elements,
                            type: "submit",
                            id: "submit",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                id: "button-text",
                                children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "flex justify-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                        className: "animate-spin ml-1 mr-3 h-5 w-5 text-white",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                                                className: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                strokeWidth: "4"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                className: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            })
                                        ]
                                    })
                                }) : "Pay"
                            })
                        })
                    ]
                }),
                message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    id: "payment-message",
                    children: message
                })
            ]
        })
    });
};
//do i need to add account here?
var Stripe = function(props) {
    var appearance = {
        theme: 'stripe'
    };
    var options = {
        clientSecret: props.clientSecret,
        appearance: appearance
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "App",
        children: props.clientSecret && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_stripe_react_stripe_js__WEBPACK_IMPORTED_MODULE_12__.Elements, {
            options: options,
            stripe: props.stripeObject,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Checkout, {
                activity: props.activity,
                meeting: props.meeting,
                setSubPage: props.setSubPage
            })
        })
    }));
};
var TimeComponent = function(props) {
    if (props.timeSlots.length < 1) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "text-center",
            style: {
                minHeight: '300px'
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    style: {
                        color: 'black'
                    },
                    children: props.selectedDate
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small", {
                        children: "No more available appointments.  Please select another date."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    className: "p-2 rounded-md hover:bg-zinc-700 bg-zinc-900 text-white",
                    onClick: function() {
                        return props.setSubPage(0);
                    },
                    children: "Return"
                })
            ]
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "w-full mx-auto py-6",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        children: "Select a time:"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "flex items-center space-x-2",
                        style: {
                            cursor: 'pointer'
                        },
                        onClick: function() {
                            return props.setSubPage(0);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: "Return"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                className: "font-bold text-xl mb-3",
                children: props.selectedDate
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "space-y-2 overflow-y-auto max-h-48 w-full mx-auto ",
                children: props.timeSlots.map(function(timeSlot) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "h-30",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                            onClick: props.saveAndContinue,
                            className: "border-2 border-slate-400 p-1 w-full font-semibold text-slate-600 bg-slate-100 rounded hover:bg-slate-400 hover:text-white",
                            value: timeSlot,
                            name: "timeSelected",
                            children: timeSlot
                        })
                    }, timeSlot);
                })
            })
        ]
    }));
};
var Confirmation = function(props) {
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), confirmed = ref11[0], setConfirmed = ref11[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), loading = ref10[0], setLoading = ref10[1];
    var alert = (0,react_alert__WEBPACK_IMPORTED_MODULE_8__/* .useAlert */ .VY)();
    var user = (0,_contexts_Auth__WEBPACK_IMPORTED_MODULE_13__/* .useAuth */ .a)().user;
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var getClientSecret = function() {
            if (props.activity.meeting_cost && props.activity.meeting_cost > 0 && !props.clientSecret && props.activity.profile.stripe_confirmed) {
                setLoading(true);
                fetch("/api/stripe/create-payment-intent", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        service_id: props.activity.id,
                        price_id: props.activity.price_id,
                        recurring: props.activity.recurring,
                        rand: props.meeting.rand,
                        marketplace: props.activity.profile.listing_id ? true : false,
                        multiple: props.activity.multiple,
                        stripe_profile_id: props.activity.profile.stripe_account_id,
                        cost: props.activity.meeting_cost,
                        billing_name: props.meeting.name,
                        billing_email: props.meeting.email,
                        client_user_id: user ? user.id : null,
                        client_profile_id: props.meeting.client_profile_id ? props.meeting.client_profile_id : null
                    })
                }).then(function(res) {
                    return res.json();
                }).then(function() {
                    var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
                        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    props.setClientSecret(data.clientSecret);
                                    setLoading(false);
                                case 2:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    return function(data) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        };
        var fetchStripeObject = function() {
            var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var res;
                return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!props.profile.stripe_account_id) {
                                _ctx.next = 5;
                                break;
                            }
                            _ctx.next = 3;
                            return (0,_stripe_stripe_js__WEBPACK_IMPORTED_MODULE_11__/* .loadStripe */ .J)(_config__WEBPACK_IMPORTED_MODULE_9__/* .dev */ .WI ? "pk_test_51Ka5CpHobLlY2U5tPudxWi7VMqEk05x00dujb8tV8rxKbDKv4NSK4TxmLSLWUPH0pHq9mMpQZdRkHsJLgJvj9N6X00heRI1KSG" : "pk_live_51Ka5CpHobLlY2U5t2jfPpkigRBV90pmoSucBdvVqet6sAKNBW0I5aNpq0ZfGtFN8uL1yebDxoQRmaWTBzAWYFBdi00GCzTaJP6", {
                                stripeAccount: props.profile.stripe_account_id
                            });
                        case 3:
                            res = _ctx.sent;
                            // When we have got the Stripe object, pass it into our useState.
                            props.setStripeObject(res);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchStripeObject() {
                return _ref.apply(this, arguments);
            };
        }();
        getClientSecret();
        fetchStripeObject();
    }, []);
    var nextStep = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            var meeting;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        meeting = props.meeting;
                        if (!(!meeting.name || !meeting.email)) {
                            _ctx.next = 6;
                            break;
                        }
                        alert.error('Please enter a name and email');
                        setLoading(false);
                        return _ctx.abrupt("return");
                    case 6:
                        console.log("runing next step");
                        // props.clientSecret && getClientSecret()
                        props.setSubPage(4);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function nextStep(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var bookDemo = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            var meeting, dateStr, appointment_datetime, timezone, durationInMinutes, duration_obj, appointmentDateTime, utc_date, payload, ref, data, error2, newMeeting;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        setLoading(true);
                        meeting = props.meeting;
                        if (!(!meeting.name || !meeting.email)) {
                            _ctx.next = 7;
                            break;
                        }
                        alert.error('Please enter a name and email');
                        setLoading(false);
                        return _ctx.abrupt("return");
                    case 7:
                        dateStr = meeting.dateStr, appointment_datetime = meeting.appointment_datetime, timezone = meeting.timezone;
                        durationInMinutes = props.activity.duration_period === "minutes" ? props.activity.duration_int : props.activity.duration_int * 60;
                        duration_obj = {
                            minutes: durationInMinutes
                        };
                        appointmentDateTime = DateTime.fromISO(appointment_datetime);
                        utc_date = appointmentDateTime.toUTC().toFormat('y-L-d-H-m').split("-").map(function(str) {
                            return parseInt(str);
                        });
                        payload = {
                            appointment_datetime: appointmentDateTime.toISO(),
                            viewer_name: meeting.name,
                            viewer_email: meeting.email,
                            notes: meeting.notes,
                            status: 'upcoming',
                            duration: durationInMinutes,
                            viewer_timezone: timezone,
                            type: '1-on-1',
                            subtype: meeting.rand,
                            user_id: props.activity.user_id,
                            activity: props.activity.id,
                            person: meeting.person,
                            client_user_id: user ? user.id : null,
                            voice_call: props.voiceCall
                        };
                        _ctx.next = 15;
                        return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_7__/* .supabase.from */ .O.from("main_meeting").insert(payload);
                    case 15:
                        ref = _ctx.sent;
                        data = ref.data;
                        error2 = ref.error;
                        if (!error2) {
                            console.log("no error");
                            _lib_gtag__WEBPACK_IMPORTED_MODULE_15__/* .event */ .B({
                                action: 'book_call'
                            });
                            newMeeting = data[0];
                            fetch('/api/contact/demo', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    email: newMeeting.viewer_email,
                                    meeting_data: {
                                        uuid: newMeeting.room_uuid,
                                        creator_iso: appointmentDateTime.setZone(props.activity.timezone).toISO(),
                                        v_appointment_datetime: appointmentDateTime.setZone(props.meeting.timezone).toLocaleString(DateTime.DATETIME_FULL),
                                        c_appointment_datetime: appointmentDateTime.setZone(props.activity.timezone).toLocaleString(DateTime.DATETIME_FULL)
                                    },
                                    creator_email: props.activity.profile.email,
                                    notes: newMeeting.notes,
                                    utc_date: utc_date,
                                    subtype: meeting.rand,
                                    duration_obj: duration_obj,
                                    creator_name: props.activity.profile.name,
                                    creator_timezone: props.activity.timezone,
                                    creator_profile_id: props.activity.profile.id,
                                    calendar_sync: props.activity.profile.calendar_sync,
                                    description: props.activity.description.substring(0, 100) + " ...",
                                    timezone: newMeeting.viewer_timezone,
                                    viewer_name: props.meeting.name,
                                    activity_title: props.activity.booking_name,
                                    id: data[0].room_uuid,
                                    voice_call: props.voiceCall,
                                    brand_logo: props.activity.profile.brand_logo,
                                    runAt: DateTime.now().plus({
                                        minutes: 1
                                    }).toISO(),
                                    remindAt: appointmentDateTime.setZone(props.meeting.timezone).plus({
                                        minutes: -60
                                    }).toISO(),
                                    endAt: appointmentDateTime.setZone(props.meeting.timezone).plus({
                                        minutes: durationInMinutes
                                    }).toISO()
                                })
                            }).then(function(response) {
                                if (!response.ok) throw new Error(response.status);
                                setConfirmed(true);
                                console.log("Register email sent");
                                setLoading(false);
                            }).catch(function(error) {
                                console.log(error);
                                alert.error("Unable to send email confirmation");
                                console.log("Unable to send email confirmation");
                                setLoading(false);
                            });
                        } else {
                            console.log(error2);
                        }
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function bookDemo(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: confirmed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "pt-5 mt-5 pb-20 text-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    className: "mx-auto mb-2 text-green-600",
                    size: 45
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                    className: "font-bold text-xl mb-5",
                    children: "Meeting confirmed!"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                    children: [
                        "You will receive a confirmation email shortly.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small", {
                            className: "text-slate-600",
                            children: " You'll also receive a video link 5 minutes before your upcoming meeting."
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "h-96    ",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "text-center",
                    children: props.activity.multiple ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        className: "font-semibold text-xl mb-3 text-slate-800",
                        children: "Enter details"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "font-bold text-xl mb-3",
                                children: props.meeting.dateStr
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "-mt-4 text-slate-600",
                                children: props.meeting.timezone
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                    className: "text-left",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "label",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                    type: "text",
                                    required: true,
                                    name: "name",
                                    className: "mt-1 px-3 py-2 disabled:bg-slate-200 disabled:text-slate-500 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-slate-500 focus:ring-slate-500 block w-full rounded-md sm:text-sm focus:ring-1",
                                    defaultValue: props.meeting.name,
                                    onChange: props.handleChange,
                                    disabled: loading || user
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "label",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                    type: "email",
                                    required: true,
                                    name: "email",
                                    className: "mt-1 px-3 py-2 disabled:bg-slate-200 disabled:text-slate-500 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-slate-500 focus:ring-slate-500 block w-full rounded-md sm:text-sm focus:ring-1",
                                    disabled: (props.meeting.viewer_profile ? true : loading ? true : false) || user,
                                    defaultValue: props.meeting.email,
                                    onChange: props.handleChange
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "label",
                                    children: "Anything you'd like to share?"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("textarea", {
                                    rows: 5,
                                    size: "sm",
                                    name: "notes",
                                    className: "mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-slate-500 focus:ring-slate-500 block w-full rounded-md sm:text-sm focus:ring-1",
                                    defaultValue: props.meeting.notes,
                                    onChange: props.handleChange
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "text-end mb-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                        className: "w-full mt-5 bg-slate-700 shadow-md shadow-slate-500/50 rounded-md py-2 text-sm font-semibold text-white text-center hover:bg-zinc-900",
                        onClick: props.activity.meeting_cost && props.activity.meeting_cost > 0 && props.activity.profile.stripe_confirmed ? nextStep : bookDemo,
                        disabled: loading,
                        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                className: "animate-spin ml-1 mr-3 h-5 w-5 text-white",
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                                        className: "opacity-25",
                                        cx: "12",
                                        cy: "12",
                                        r: "10",
                                        stroke: "currentColor",
                                        strokeWidth: "4"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        className: "opacity-75",
                                        fill: "currentColor",
                                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    })
                                ]
                            })
                        }) : props.activity.meeting_cost && props.activity.meeting_cost > 0 && props.activity.profile.stripe_confirmed ? 'Continue to Billing' : 'Set Appointment'
                    })
                })
            ]
        })
    }));
};
var MeetingPreview = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), previewMeetings = ref[0], setPreviewMeetings = ref[1];
    var container = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)();
    var isOverflown = function() {
        var element = container.current;
        return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var newMeetings = [];
        var totalWeeks = props.activity.schedule_period === "week" ? props.activity.schedule_int : props.activity.schedule_int * 4;
        var allMeetingDates = [];
        var selectedDatesForWeek = _toConsumableArray(props.meeting.meeting_dates);
        var index = 0;
        for(var i = 0; i < totalWeeks; i++){
            var newWeek = [];
            for(var j = 0; j < props.activity.weekly_meeting_amount; j++){
                newWeek.push(selectedDatesForWeek[j]);
                allMeetingDates.push(selectedDatesForWeek[j]);
                selectedDatesForWeek[j] = DateTime.fromISO(selectedDatesForWeek[j]).plus({
                    weeks: 1
                }).toISO();
                index++;
            }
            newMeetings.push(newWeek);
        }
        //handle meeting
        var ev = {
            target: {
                name: "meeting_dates",
                value: allMeetingDates
            }
        };
        props.handleChange(ev);
        setPreviewMeetings(newMeetings);
    }, []);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                className: "text-lg font-bold mb-3",
                children: "Does this schedule work for you?"
            }),
            props.activity.recurring && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                className: "text-slate-500 text-xs italic -mt-3",
                children: "*This schedule will repeat monthly. Rescheduling available when needed"
            }),
            previewMeetings.length < 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                    className: "animate-spin ml-1 mr-3 h-5 w-5 text-slate-500",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                            className: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            strokeWidth: "4"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                            className: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "h-72 overflow-y-scroll ",
                        ref: container,
                        children: previewMeetings.map(function(arr, index) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                        className: " font-semibold text-slate-500",
                                        children: [
                                            "Week ",
                                            index + 1
                                        ]
                                    }),
                                    arr.map(function(str) {
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                            className: "text-sm",
                                            children: [
                                                DateTime.fromISO(str).setZone(props.meeting.timezone).toFormat("fff"),
                                                " "
                                            ]
                                        }, str);
                                    })
                                ]
                            }, "pm-".concat(index));
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                        className: "w-full mt-5 bg-slate-700 shadow-md shadow-slate-500/50 rounded-md py-2 text-sm font-semibold text-white text-center hover:bg-zinc-900",
                        onClick: props.nextStep,
                        children: "Continue"
                    })
                ]
            })
        ]
    }));
};
var Calendar = function(props) {
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), activity = ref14[0], setActivity = ref14[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), meetings1 = ref12[0], setMeetings = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), stripeObject = ref13[0], setStripeObject = ref13[1];
    var alert = (0,react_alert__WEBPACK_IMPORTED_MODULE_8__/* .useAlert */ .VY)();
    var user = (0,_contexts_Auth__WEBPACK_IMPORTED_MODULE_13__/* .useAuth */ .a)().user;
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var getActivity = function() {
            var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, data, error, meetings;
                return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_7__/* .supabase.from */ .O.from("main_activity").select("id, user_id, start_date, booking_slug, price_id, description, messaging, recurring, meeting_cost, multiple, require_signup, weekly_meeting_amount, sessions, schedule_period, schedule_int, student_limit, session_amount, status, booking_name, duration_int, duration_period, type, timezone, main_opening_hours (opening_time, closing_time, days),\n            future_limit_int, buffer_time_int, buffer_time_period, future_limit_period, duration_int, duration_period, min_booking_notice_int, min_booking_notice_period, profile (id, name, calendar_sync, full_name, email, user_image, brand_logo, stripe_confirmed, stripe_account_id, events, listing_id (id, type))\n            ").eq('booking_slug', props.slug);
                        case 2:
                            ref = _ctx.sent;
                            data = ref.data;
                            error = ref.error;
                            console.log(props.slug);
                            if (data[0].require_signup) {
                                setSubPage(-2);
                            }
                            error && console.log(error);
                            _ctx.next = 10;
                            return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_7__/* .supabase.from */ .O.from("main_meeting").select("user_id, appointment_datetime, duration, activity, room_uuid, status, type").in("status", [
                                "upcoming",
                                "live"
                            ]).eq("user_id", data[0].user_id);
                        case 10:
                            meetings = _ctx.sent;
                            meetings.error && console.log(meetings.error);
                            setMeetings(meetings.data);
                            setActivity(data[0]);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getActivity() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!props.activity) {
            getActivity();
        } else {
            setActivity(props.activity) //should probably change this
            ;
            setMeetings(props.meetings);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var getProfile = function() {
            var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(u) {
                var ref, data, error;
                return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_7__/* .supabase.from */ .O.from("main_profile").select("id, name, user_id, email").match({
                                user_id: u.id
                            });
                        case 2:
                            ref = _ctx.sent;
                            data = ref.data;
                            error = ref.error;
                            props.handleUser({
                                email: data[0].email,
                                name: data[0].name,
                                id: u.id,
                                profile_id: data[0].id
                            });
                            console.log("user found");
                            if (props.subPage !== -1) {
                                props.setSubPage(0);
                            }
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getProfile(u) {
                return _ref.apply(this, arguments);
            };
        }();
        if (user && props.checkUser && activity) {
            getProfile(user);
        }
    }, [
        activity
    ]);
    var nextStep = function() {
        props.setSubPage(function(prevState) {
            return prevState + 1;
        });
    };
    var checkMeetings = function(meets) {
        var sortedArr = meets.sort(function(a, b) {
            return a < b ? -1 : a > b ? 1 : 0;
        });
        var start = DateTime.fromISO(sortedArr[0]);
        var end = DateTime.fromISO(sortedArr[sortedArr.length - 1]);
        var diffInDays = end.diff(start, 'days');
        if (diffInDays.days > 7) {
            alert.error("Select ".concat(activity.weekly_meeting_amount, " dates in the same week"));
            return false;
        }
        console.log("returinng true");
        return true;
    };
    var saveAndContinue = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            var newMeeting, dt;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        newMeeting = _objectSpread({}, props.meeting);
                        newMeeting.dateStr = newMeeting.dateStr + ' ' + e.target.value;
                        dt = DateTime.fromFormat(newMeeting.dateStr, 'DD h:m a').setZone(props.meeting.timezone) //might need to fix this???
                        ;
                        if (activity.multiple) {
                            newMeeting.meeting_dates.push(dt.toISO());
                            props.setMeeting(newMeeting);
                            if (newMeeting.meeting_dates.length >= activity.weekly_meeting_amount) {
                                if (checkMeetings(newMeeting.meeting_dates)) {
                                    props.setSubPage(2);
                                } else {
                                    //handle error here
                                    newMeeting.meeting_dates.pop();
                                    props.setSubPage(0);
                                }
                            } else {
                                props.setSubPage(0);
                            }
                        } else {
                            newMeeting.appointment_datetime = dt.toISO();
                            props.setMeeting(newMeeting);
                            props.setSubPage(3);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function saveAndContinue(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var addTimeSlots = function(dateStr) {
        var ref;
        //get associated opening hours from click
        var daySelected = DateTime.fromISO(dateStr);
        var dayInCreatorTimeZone = daySelected.setZone(activity.timezone);
        var duration_int = activity.duration_int, duration_period = activity.duration_period, buffer_time_int = activity.buffer_time_int, buffer_time_period = activity.buffer_time_period, main_opening_hours = activity.main_opening_hours, min_booking_notice_int = activity.min_booking_notice_int, min_booking_notice_period = activity.min_booking_notice_period;
        var durObj = _defineProperty({}, duration_period, duration_int);
        var bufferObj = _defineProperty({}, buffer_time_period, buffer_time_int);
        var minObj = _defineProperty({}, min_booking_notice_period, min_booking_notice_int);
        var blocked = meetings1.filter(function(obj) {
            return new Date(obj.appointment_datetime).today === new Date().today;
        }) //change to user timmezone
        ;
        var calEvents = (ref = activity.profile) === null || ref === void 0 ? void 0 : ref.events;
        var booked = [];
        //add blocked here
        if (calEvents) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = calEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var cal = _step.value;
                    var b = DateTime.fromISO(cal.start.dateTime).setZone(props.meeting.timezone);
                    var diff = DateTime.fromISO(cal.end.dateTime).diff(DateTime.fromISO(cal.start.dateTime), "minutes").toObject();
                    var minutes = diff.minutes;
                    booked.push({
                        dt: b,
                        data: {
                            duration: minutes
                        }
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        if (blocked) {
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = blocked[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var block = _step1.value;
                    var blockDt = DateTime.fromISO(block.appointment_datetime).setZone(props.meeting.timezone);
                    if (blockDt.day === daySelected.day && blockDt.year === daySelected.year && blockDt.month === daySelected.month) {
                        booked.push({
                            dt: blockDt,
                            data: block
                        });
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
        var timeStops = [];
        var currDate = DateTime.now().setZone(props.meeting.timezone);
        var minDate = currDate.plus(minObj);
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = main_opening_hours[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var openingHours = _step2.value;
                // #add this validation to days BEFOREHAND at some point!!!
                if (openingHours.days.includes(dayInCreatorTimeZone.toFormat('cccc'))) {
                    var openTimeArr = openingHours.opening_time.split(":") //parse date string
                    ;
                    var closeTimeArr = openingHours.closing_time.split(":");
                    var oTime = dayInCreatorTimeZone.set({
                        hour: openTimeArr[0],
                        minute: openTimeArr[1]
                    }) //set time
                    ;
                    var cTime = dayInCreatorTimeZone.set({
                        hour: closeTimeArr[0],
                        minute: closeTimeArr[1]
                    });
                    var userOTime = oTime.setZone(props.meeting.timezone);
                    var userCTime = cTime.setZone(props.meeting.timezone);
                    var dateCheck = userOTime.plus(durObj);
                    var excluded = [];
                    while(dateCheck < userCTime){
                        var timeSlot = userOTime;
                        //check if time is before minimum booking notice
                        if (timeSlot > minDate) {
                            var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                            try {
                                for(var _iterator3 = booked[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                    var b1 = _step3.value;
                                    // if (timeSlot.toFormat('h:mm a') !== b.dt.toFormat('h:mm a')) {
                                    //   console.log(b.dt.toFormat('h:mm a'), timeSlot.toFormat('h:mm a'))
                                    // }
                                    //check if:
                                    // are there a booked meetings this day
                                    // is booked at the same time
                                    // does not interfere with buffer time before or after
                                    //check middle condition since buffer object need to be factored in
                                    if (timeSlot !== b1.dt && timeSlot.plus(durObj).plus(bufferObj) < b1.dt.minus(bufferObj) || b1.dt.plus({
                                        minutes: b1.data.duration
                                    }).plus(bufferObj) <= timeSlot) {
                                        timeStops.push(timeSlot.toFormat('h:mm a'));
                                        continue;
                                    } else {
                                        excluded.push(timeSlot.toFormat('h:mm a'));
                                    }
                                }
                            } catch (err) {
                                _didIteratorError3 = true;
                                _iteratorError3 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                        _iterator3.return();
                                    }
                                } finally{
                                    if (_didIteratorError3) {
                                        throw _iteratorError3;
                                    }
                                }
                            }
                            if (booked.length === 0) {
                                timeStops.push(timeSlot.toFormat('h:mm a'));
                            }
                        }
                        userOTime = userOTime.plus(durObj);
                        dateCheck = dateCheck.plus(durObj);
                    }
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        timeStops = timeStops.filter(function(obj) {
            return !excluded.includes(obj);
        });
        timeStops = _toConsumableArray(new Set(timeStops));
        timeStops.sort(function(a, b) {
            return Date.parse('01/01/2012 ' + a) - Date.parse('01/01/2012 ' + b);
        }); //sorts times in array from earliest to latest
        return timeStops;
    };
    if (!activity || !meetings1) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                className: "animate-spin h-10 w-10 my- text-zinc-500 ",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                        className: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        strokeWidth: "4"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        className: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                ]
            })
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "jsx-d27df37b20391b58" + " " + "text-center bg-white z-4 h-full w-full relative  ",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "jsx-d27df37b20391b58" + " " + "text-left w-full  flex-col md:space-x-5 md:flex-row flex justify-between items-center relative",
                    children: [
                        props.business && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "jsx-d27df37b20391b58" + " " + ' w-3/4 sm:w-1/2 relative px-5 sm:px-10 py-5 ',
                            children: [
                                activity.profile.brand_logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "jsx-d27df37b20391b58" + " " + ' mb-5 flex w-full justify-center',
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                        src: "".concat(_config__WEBPACK_IMPORTED_MODULE_9__/* .cloudfront */ .bG, "/").concat(activity.profile.brand_logo),
                                        width: 70,
                                        height: 35,
                                        alt: activity.profile.name,
                                        objectFit: "contain"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "jsx-d27df37b20391b58" + " " + 'flex  flex-col text-2xl font-semibold items-start mb-3',
                                    children: [
                                        activity.profile.user_image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                            className: (_styles_Userpage_module_css__WEBPACK_IMPORTED_MODULE_20___default().img_src),
                                            src: "".concat(_config__WEBPACK_IMPORTED_MODULE_9__/* .cloudfront */ .bG, "/").concat(activity.profile.user_image),
                                            width: 50,
                                            height: 50,
                                            alt: activity.profile.username,
                                            objectFit: "cover"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h5", {
                                            className: "jsx-d27df37b20391b58" + " " + 'text-lg font-semibold text-slate-800',
                                            children: activity.profile.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                    className: "jsx-d27df37b20391b58" + " " + "font-extrabold text-2xl text-gray-900  ",
                                    children: activity.booking_name
                                }),
                                activity.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "jsx-d27df37b20391b58" + " " + 'text-sm w-full text-zinc-500 mb-3',
                                    children: activity.description
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "jsx-d27df37b20391b58" + " " + "mb-3 flex-col space-y-1 text-slate-500",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "jsx-d27df37b20391b58" + " " + "flex space-x-2 items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                    className: "",
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                    className: "jsx-d27df37b20391b58" + " " + "text-sm font-semibold",
                                                    children: "Video Conference"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "jsx-d27df37b20391b58" + " " + "flex space-x-2 items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                                    className: "",
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                    className: "jsx-d27df37b20391b58" + " " + "text-sm font-semibold",
                                                    children: [
                                                        activity.duration_int,
                                                        " ",
                                                        activity.duration_period
                                                    ]
                                                })
                                            ]
                                        }),
                                        activity.multiple && activity.profile.stripe_confirmed && (activity === null || activity === void 0 ? void 0 : activity.meeting_cost) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "jsx-d27df37b20391b58" + " " + "flex space-x-2 items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                                    className: "",
                                                    size: 16
                                                }),
                                                activity.recurring ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                    className: "jsx-d27df37b20391b58" + " " + "text-sm font-semibold",
                                                    children: [
                                                        activity.weekly_meeting_amount,
                                                        " ",
                                                        activity.weekly_meeting_amount > 1 ? "sessions" : "session",
                                                        " a week"
                                                    ]
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                    className: "jsx-d27df37b20391b58" + " " + "text-sm font-semibold",
                                                    children: [
                                                        activity.weekly_meeting_amount,
                                                        " ",
                                                        activity.weekly_meeting_amount > 1 ? "sessions" : "session",
                                                        " a week for ",
                                                        activity.schedule_int,
                                                        " ",
                                                        activity.schedule_int > 1 ? activity.schedule_period + "s" : activity.schedule_period
                                                    ]
                                                })
                                            ]
                                        }),
                                        activity.meeting_cost && activity.meeting_cost > 0 && activity.profile.stripe_confirmed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "jsx-d27df37b20391b58" + " " + "flex space-x-2 items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                                    className: "",
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                    className: "jsx-d27df37b20391b58" + " " + "text-sm font-semibold",
                                                    children: [
                                                        activity.meeting_cost,
                                                        activity.recurring && "/mo"
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: "jsx-d27df37b20391b58"
                                        }),
                                        activity.messaging && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "jsx-d27df37b20391b58" + " " + 'flex space-x-2 items-center',
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {}),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    onClick: function() {
                                                        return props.setSubPage(-1);
                                                    },
                                                    className: "jsx-d27df37b20391b58" + " " + 'text-sm font-semibold hover:underline',
                                                    children: "Ask a question"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            style: {
                                minHeight: "464px"
                            },
                            className: "jsx-d27df37b20391b58" + " " + " ".concat(props.business ? "sm:py-10 w-full sm:px-20 md:px-10 md:w-1/2 bg-slate-200" : " w-full bg-slate-100", " pt-10 px-4 "),
                            children: [
                                props.subPage === 0 || props.subPage === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "jsx-d27df37b20391b58" + " " + "text-center w-full flex justify-center items-center space-x-3 mb-1 mt-5",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "jsx-d27df37b20391b58" + " " + 'w-full ',
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(timezone_select_js__WEBPACK_IMPORTED_MODULE_10__/* .TimezoneSelect */ .Cc, {
                                            value: props.meeting.timezone,
                                            onChange: props.handleTimeChange
                                        })
                                    })
                                }),
                                props.subPage === -2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RegisterSlide, {
                                    activity: activity,
                                    setCheckUser: props.setCheckUser,
                                    handleUser: props.handleUser,
                                    profile: activity.profile,
                                    setSubPage: props.setSubPage
                                }),
                                props.subPage === -1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SendMessage, {
                                    activity: activity,
                                    profile: activity.profile
                                }),
                                props.subPage === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "jsx-d27df37b20391b58" + " " + ' -ml-5 ',
                                    children: [
                                        activity.multiple ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "jsx-d27df37b20391b58" + " " + 'mb-5 pt-2',
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                                    className: "jsx-d27df37b20391b58" + " " + "font-semibold text-lg pt-2 text-slate-900 text-center",
                                                    children: activity.weekly_meeting_amount > 1 ? "Select ".concat(activity.weekly_meeting_amount, " dates in the same week") : "Select a date"
                                                }),
                                                props.meeting.meeting_dates.map(function(obj, index) {
                                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                        className: "jsx-d27df37b20391b58" + " " + "text-slate-600 text-sm border text-center mb-1 p-1 rounded bg-slate-100 border-slate-400",
                                                        children: [
                                                            "Date ",
                                                            index + 1 + ": ",
                                                            DateTime.fromISO(obj).setZone(props.meeting.timezone).toFormat("fff")
                                                        ]
                                                    }, obj);
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: "jsx-d27df37b20391b58" + " " + 'font-semibold text-lg pt-2 text-slate-900 text-center',
                                            children: "Select a date"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "jsx-d27df37b20391b58" + " " + 'mt-5',
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_flatpickr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                "data-enable-time": true,
                                                options: {
                                                    minDate: 'today',
                                                    //Displays the calendar at all times
                                                    inline: true,
                                                    //what's displayed in the input
                                                    altFormat: 'Z',
                                                    // enable dates
                                                    enable: [
                                                        function(date) {
                                                            //check if today is disabled or not
                                                            var dateDay = date.getDay();
                                                            var days = [];
                                                            var dayInts = [];
                                                            var copy = _toConsumableArray(activity.main_opening_hours);
                                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                            try {
                                                                for(var _iterator = copy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                                    var obj = _step.value;
                                                                    days = days.concat(obj.days);
                                                                }
                                                            } catch (err) {
                                                                _didIteratorError = true;
                                                                _iteratorError = err;
                                                            } finally{
                                                                try {
                                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                                        _iterator.return();
                                                                    }
                                                                } finally{
                                                                    if (_didIteratorError) {
                                                                        throw _iteratorError;
                                                                    }
                                                                }
                                                            }
                                                            var dayMap = {
                                                                "Sunday": 0,
                                                                "Monday": 1,
                                                                "Tuesday": 2,
                                                                "Wednesday": 3,
                                                                "Thursday": 4,
                                                                "Friday": 5,
                                                                "Saturday": 6
                                                            };
                                                            var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                                                            try {
                                                                for(var _iterator4 = days[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                                                    var str = _step4.value;
                                                                    dayInts.push(dayMap[str]);
                                                                }
                                                            } catch (err) {
                                                                _didIteratorError4 = true;
                                                                _iteratorError4 = err;
                                                            } finally{
                                                                try {
                                                                    if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                                                        _iterator4.return();
                                                                    }
                                                                } finally{
                                                                    if (_didIteratorError4) {
                                                                        throw _iteratorError4;
                                                                    }
                                                                }
                                                            }
                                                            return dayInts.includes(dateDay) //fix this to adjust for timezone
                                                            ;
                                                        }
                                                    ],
                                                    dateFormat: "Y-m-d",
                                                    //Show the user a readable date (as per altFormat), but return something totally different to the server.
                                                    altInput: false,
                                                    //show time on calendar
                                                    enableTime: false,
                                                    //# of days available (only takes in weeks)
                                                    maxDate: new Date().fp_incr(activity.future_limit_period === "weeks" ? activity.future_limit_int * 7 : activity.future_limit_int)
                                                },
                                                // handle input change event
                                                onChange: function(selectedDates, dateStr, instance) {
                                                    var dtArr = dateStr.split('-');
                                                    var dt = DateTime.fromObject({
                                                        year: dtArr[0],
                                                        month: dtArr[1],
                                                        day: dtArr[2]
                                                    }, {
                                                        zone: props.meeting.timezone
                                                    });
                                                    props.handleDateStr(dt);
                                                    props.setSubPage(1);
                                                }
                                            })
                                        })
                                    ]
                                }),
                                props.subPage === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TimeComponent, {
                                    selectedDate: props.meeting.dateStr,
                                    timeSlots: addTimeSlots(props.meeting.appointment_datetime),
                                    activity: activity,
                                    saveAndContinue: saveAndContinue,
                                    handleChange: props.handleChange,
                                    setSubPage: props.setSubPage,
                                    business: props.business
                                }),
                                props.subPage === 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MeetingPreview, {
                                    meeting: props.meeting,
                                    activity: activity,
                                    saveAndContinue: saveAndContinue,
                                    handleChange: props.handleChange,
                                    nextStep: nextStep,
                                    setSubPage: props.setSubPage,
                                    business: props.business
                                }),
                                props.subPage === 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Confirmation, {
                                    meeting: props.meeting,
                                    voiceCall: props.voiceCall,
                                    handleChange: props.handleChange,
                                    activity: activity,
                                    profile: activity.profile,
                                    business: props.business,
                                    setSubPage: props.setSubPage,
                                    clientSecret: props.clientSecret,
                                    setClientSecret: props.setClientSecret,
                                    setStripeObject: setStripeObject
                                }),
                                props.subPage === 4 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Stripe, {
                                    meeting: props.meeting,
                                    handleChange: props.handleChange,
                                    activity: activity,
                                    profile: activity.profile,
                                    business: props.business,
                                    setSubPage: props.setSubPage,
                                    clientSecret: props.clientSecret,
                                    stripeObject: stripeObject
                                })
                            ]
                        })
                    ]
                }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_2___default()), {
                    id: "d27df37b20391b58",
                    children: "a{cursor:pointer!important}\n.flatpickr-dateStr{font-size:115%;\nline-height:inherit;\nfont-weight:300;\ncolor:#484848!important;\nposition:static;\nwidth:75%;\nleft:12.5%;\npadding:7.48px 0 0 0;\nline-height:1;\nheight:34px;\ndisplay:inline-block;\ntext-align:center;\n-webkit-transform:translate3d(0px, 0px, 0px);\n-webkit-transform:translate3d(0px, 0px, 0px);\n-moz-transform:translate3d(0px, 0px, 0px);\n-ms-transform:translate3d(0px, 0px, 0px);\ntransform:translate3d(0px, 0px, 0px)}\n.flatpickr-days, .flatpickr-innerContainer{border:none!important;\nbackground:none;\ndisplay:inline-block!important}\n.flatpickr-current-month{font-size:16px;\ncolor:#484848!important}\n.flatpickr-month, .flatpickr-monthDropdown-months, .cur-year{background:none!important;\ncolor:#484848!important;\nfont-weight:500!important}\n.flatpickr-weekdays, .flatpickr-weekday{background:none!important;\ntext-transform:uppercase;\ncolor:#484848!important}\n.flatpickr-input{display:none!important}\n.flatpickr-day.selected{background:rgb(49, 35, 101)!important;\nborder-color:rgb(49, 35, 101)!important}\n.flatpickr-prev-month, .flatpickr-next-month{fill:black!important}\n.flatpickr-monthDropdown-month{background-color:white!important}\n.flatpickr-day :not(.flatpickr-disabled){background:rgb(49, 35, 101)!important;\nborder:rgb(49, 35, 101)!important}\n.flatpickr-day{font-weight:600}\n.flatpickr-day:hover, .flatpickr-day.today:hover{background-color:rgb(226 232 240)!important;\nborder-color:#ffffff;\nborder-width:2px;\ncolor:black}\n.flatpickr-day.today{border:1.5px solid #BBBBB}\n.flatpickr-calendar{box-shadow:none;\nborder:none;\nfont-weight:normal;\nmargin:auto;\nwidth:auto}\n@media only screen and (max-width:340px) {.flatpickr-calendar{margin:auto;\nwidth:auto}\n.flatpickr-innerContainer{overflow:scroll!important;\nwidth:250px;\nmargin:auto}}\n@media only screen and (max-width:290px) {.flatpickr-calendar{margin:auto;\nwidth:auto}\n.flatpickr-innerContainer{overflow:scroll!important;\nwidth:200px;\nmargin:auto}}\n@media only screen and (max-width:600px) {.time-col{overflow-y:scroll;\nheight:400px!important}}\n.font{font-size:13.3333px!important;\nfont-weight:400!important}\n.time-col{overflow-y:scroll;\nheight:290px}\n::-webkit-scrollbar{width:0px}\n.label{font-size:90%;\ncolor:grey;\nline-height:1}\n.result-message{line-height:22px;\nfont-size:16px}\n.result-message a{color:rgb(89, 111, 214);\nfont-weight:600;\n-webkit-text-decoration:none;\ntext-decoration:none}\n.hidden{display:none}\n#card-error{color:rgb(105, 115, 134);\nfont-size:16px;\nline-height:20px;\nmargin-top:12px;\ntext-align:center}\n#card-element{border-radius:4px 4px 0 0;\npadding:12px;\nborder:1px solid rgba(50, 50, 93, 0.1);\nmax-height:44px;\nwidth:100%;\nbackground:white;\nbox-sizing:border-box}\n#payment-request-button{margin-bottom:32px}\n@keyframes loading {0% {-webkit-transform:rotate(0deg);\ntransform:rotate(0deg)}100% {-webkit-transform:rotate(360deg);\ntransform:rotate(360deg)}}\n.timezone-picker-textfield input{border:none;\nbackground:none;\nwidth:200px}\n#appDetails{white-space:pre}\n.schedule-card{width:21rem;\nheight:10rem;\nbackground-color:#F4E7EC;\nborder-style:solid;\nborder-width:3px;\ncolor:rgb(97, 8, 42);\nborder-radius:.3rem!important}\n.schedule-card-add{background-color:#fff!important;\nborder-style:dashed}\n.schedule-card-add:hover{background-color:#F4E7EC!important;\n-webkit-text-decoration:none;\ntext-decoration:none}\n.center-schedule{position:relative;\ntop:50%;\nleft:50%;\n-webkit-transform:translate(-50%, -50%);\n-moz-transform:translate(-50%, -50%);\n-ms-transform:translate(-50%, -50%);\ntransform:translate(-50%, -50%);\nfont-size:14px}\n.item-center{display:grid;\ngrid-auto-flow:column;\ngap:4px;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\njustify-items:center}"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Calendar);


/***/ }),

/***/ 15094:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"img_con":"Userpage_img_con__7Xwc0","img_src":"Userpage_img_src__5VYs8","img_middle":"Userpage_img_middle__7bmOK","center_spinner":"Userpage_center_spinner__Y4TmB","loader_con":"Userpage_loader_con__ucjlF","trash":"Userpage_trash__GnKcj","tableRow":"Userpage_tableRow__u_Cgg","header_row":"Userpage_header_row__9U8ew","header_selected":"Userpage_header_selected__VR5Qi","header_not_selected":"Userpage_header_not_selected__iYQFa","conversation_profile_row":"Userpage_conversation_profile_row__pAcQm","message_profile_row":"Userpage_message_profile_row__e5t_K","message_profile":"Userpage_message_profile__vYXVN","message_body":"Userpage_message_body__dsYcG","message_date":"Userpage_message_date__eyIax","convo_date":"Userpage_convo_date__bP59s","progress_card":"Userpage_progress_card__iGqij","progress_row":"Userpage_progress_row__YXGEU","progress_test":"Userpage_progress_test__E2CHK","progress_icon":"Userpage_progress_icon__dvI3x","class_outline":"Userpage_class_outline__ZBNCw","btn_grad":"Userpage_btn_grad__CEXVl"};

/***/ })

}]);